import type { ApprovalVerb } from '../models/platformAction.types'
import { classifyError } from '../service/classifyError'

import type { ApprovalDecisionApi, FlowResult } from './platformActionFlow.types'

export interface DecideApprovalFlowDeps {
  api: ApprovalDecisionApi
}

/**
 * One approver verb. The response is a hint, not the truth — the caller refetches the inbox — so
 * nothing is written to a store here. A refusal comes back classified with the backend's sentence
 * in `detail`: which of the three gates closed (route role, `required_role`, maker-checker) is
 * only in that sentence, so the UI prints it rather than a paraphrase.
 */
export class DecideApprovalFlow {
  constructor(private readonly deps: DecideApprovalFlowDeps) {}

  async execute(
    workspaceId: number,
    actionId: string,
    verb: ApprovalVerb,
    comment?: string,
  ): Promise<FlowResult<ApprovalVerb>> {
    try {
      if (verb === 'approve') await this.deps.api.approve(workspaceId, actionId, comment)
      else if (verb === 'reject') await this.deps.api.reject(workspaceId, actionId, comment)
      else await this.deps.api.cancel(workspaceId, actionId)
      return { ok: true, value: verb }
    } catch (cause) {
      return { ok: false, error: classifyError(cause) }
    }
  }
}
